

















import { Component } from 'vue-property-decorator';

import ProductFeature from './ProductFeature';

@Component
export default class FeatureBulletsFeature extends ProductFeature { }

